export default function upper(input: string): string {
  return input.toLocaleUpperCase();
}
